import { render, staticRenderFns } from "./UserSelectMultipleDropdownComponent.vue?vue&type=template&id=8fb818ac"
import script from "./UserSelectMultipleDropdownComponent.vue?vue&type=script&lang=ts"
export * from "./UserSelectMultipleDropdownComponent.vue?vue&type=script&lang=ts"
import style0 from "./UserSelectMultipleDropdownComponent.vue?vue&type=style&index=0&id=8fb818ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports